import { useQuery } from '@tanstack/react-query'
import { useLocation } from 'react-router-dom'

import { ApiUrlPath, X_AUTH_TOKEN, Filter, AppMsg } from 'cat-shared/utils'
import { TEN_MINUTES_IN_MS } from 'client/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

export type TGetTopUsersData = {
  questionsCount: number
  data: [
    {
      _id: string
      username: string
      answeredCount: number
      answeredCorrectCount: number
    },
  ]
}

type TError = {
  msg: AppMsg
}

export default (destination: 'HOME' | 'BEST') => {
  const { pathname } = useLocation()

  const getTopUsers = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const res = await fetch(ApiUrlPath.GetTopUsers, {
      headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
      signal: abortController.signal,
    })

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TGetTopUsersData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<TGetTopUsersData, TError>(
    [ApiUrlPath.GetTopUsers, Filter.Top, destination],
    getTopUsers,
    {
      enabled: ['/home', '/best'].includes(pathname),
      keepPreviousData: true,
      refetchInterval: TEN_MINUTES_IN_MS,
      refetchIntervalInBackground: true,
      staleTime: pathname === '/home' ? TEN_MINUTES_IN_MS : 0,
    }
  )
}
